import { Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import PublicLayout from "@/components/layout/PublicLayout";
import AdminLayout from "@/components/layout/AdminLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import PackagesList from "@/pages/PackagesList";
import PackageDetail from "@/pages/PackageDetail";
import Transportation from "@/pages/Transportation";
import VehicleDetail from "@/pages/VehicleDetail";
import Destinations from "@/pages/Destinations";
import Services from "@/pages/Services";
import Gallery from "@/pages/Gallery";
import Testimonials from "@/pages/Testimonials";
import Faqs from "@/pages/Faqs";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminHero from "@/pages/admin/AdminHero";
import AdminPackages from "@/pages/admin/AdminPackages";
import AdminServices from "@/pages/admin/AdminServices";
import AdminVehicles from "@/pages/admin/AdminVehicles";
import AdminVehicleCategories from "@/pages/admin/AdminVehicleCategories";
import AdminDestinations from "@/pages/admin/AdminDestinations";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminFaqs from "@/pages/admin/AdminFaqs";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminHomepage from "@/pages/admin/AdminHomepage";
import AdminProfile from "@/pages/admin/AdminProfile";
import AdminActivity from "@/pages/admin/AdminActivity";
import AdminTrendingPopup from "@/pages/admin/AdminTrendingPopup";
import ProtectedRoute from "@/components/ProtectedRoute";

export default function App() {
  return (
    <div className="App">
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/packages" element={<PackagesList />} />
          <Route path="/packages/:slug" element={<PackageDetail />} />
          <Route path="/transportation" element={<Transportation />} />
          <Route path="/transportation/:slug" element={<VehicleDetail />} />
          <Route path="/destinations" element={<Destinations />} />
          <Route path="/services" element={<Services />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Route>

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="leads" element={<AdminLeads />} />
          <Route path="hero" element={<AdminHero />} />
          <Route path="homepage" element={<AdminHomepage />} />
          <Route path="packages" element={<AdminPackages />} />
          <Route path="services" element={<AdminServices />} />
          <Route path="vehicles" element={<AdminVehicles />} />
          <Route path="vehicle-categories" element={<AdminVehicleCategories />} />
          <Route path="destinations" element={<AdminDestinations />} />
          <Route path="gallery" element={<AdminGallery />} />
          <Route path="testimonials" element={<AdminTestimonials />} />
          <Route path="faqs" element={<AdminFaqs />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="profile" element={<AdminProfile />} />
          <Route path="activity" element={<AdminActivity />} />
          <Route path="trending-popup" element={<AdminTrendingPopup />} />
        </Route>

        <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}
